<template>
  <router-link
    :to="{
      name: 'm3_revision',
      params: {sequence_id: revisionId.sequenceProtoId, level_num: revisionId.number, level_id: revisionId.protoId, revision: revisionId.revision},
      query: queryObject,
    }"
  >
    <slot></slot>
  </router-link>
</template>

<script>
import { convertOptionalValueToQueryParam } from '../../util.js';

export default {
  name: 'RevisionLink',

  props: {
    revisionId: {
      type: Object,
      required: true,
    },

    audienceId: {
      type: Number,
      default: null,
    },
  },

  computed: {
    queryObject() {
      return {
        audience: convertOptionalValueToQueryParam(this.audienceId),
      };
    },
  },
}
</script>
